import styled from "styled-components";
import zIndexTypes from "../../../theme/zIndexTypes";
import { mediaMaxWidth } from "../../utils/mediaQueriesTemplate";

export const Wrapper = styled.div`
  margin: 57px 0 0 60px;
  display: flex;
  justify-content: center;
  background-color: #e4e5e7;
  padding: 10px 0;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  .fadeIn {
    animation-name: fadeIn;
  }

  @keyframes fadeInDown {
    from {
      opacity: 0;
      transform: translate3d(0, -100%, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  .fadeInDown {
    animation-name: fadeInDown;
    animation-duration: 0.3s !important;
  }

  .animated {
    animation-duration: 0.7s;
    animation-fill-mode: both;
  }

  .delay-1 {
    animation-delay: 0.15s;
  }

  .delay-2 {
    animation-delay: 0.25s;
  }

  .delay-3 {
    animation-delay: 0.35s;
  }

  .delay-4 {
    animation-delay: 0.45s;
  }

  ${mediaMaxWidth.tablet`
    margin: 57px 0 0 0;
  `}
`;
export const Inner = styled.div`
  width: 960px;
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  flex-flow: row wrap;
`;

export const EditButtonLink = styled.a`
  position: fixed;
  z-index: ${zIndexTypes.actionBarItem};
  right: 10px;
  top: 72px;
  border-radius: 50%;
  transition: 0.2s ease-in-out;

  ${mediaMaxWidth.tablet`
    &.downScroll {
      top: 12px;
    }
  `}

  ${mediaMaxWidth.phone`
    right: 10px;
  `}
`;

export const EditButton = styled.div`
  width: 33px;
  height: 33px;
  border-radius: 50%;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: 1px solid #fff;
  transition: 0.1s ease-in-out;

  svg {
    color: #79D9D9;
    transition: 0.1s ease-in-out;
    font-size: 0.95em;
  }

  &:hover {
    background-color: #402680;

    svg {
      color: #fff;
    }
  }
`;
